/* Native Shopify collection filtering; every request covers the full collection. */
if (!customElements.get('shp-cart-finder')) customElements.define('shp-cart-finder', class extends HTMLElement {
  connectedCallback() {
    this.classList.add('js-ready');
    this.addEventListener('change', event => {
      const target = event.target;
      if (!target.matches('input[type="radio"], select[name="sort_by"]')) return;
      const url = new URL(this.pending || location.href);
      url.searchParams.delete('page');
      url.searchParams.delete(target.name);
      if (target.value) url.searchParams.set(target.name, target.value);
      this.load(url);
    });
    this.addEventListener('submit', event => event.preventDefault());
    this.addEventListener('click', event => {
      const link = event.target.closest('[data-filter-link]');
      if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); this.load(new URL(link.href));
      }
      if (event.target.closest('[data-retry]') && this.pending) this.load(this.pending);
    });
  }
  async load(url, historyUpdate = true) {
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    this.pending = url;
    this.controller?.abort();
    this.controller = new AbortController();
    const sequence = this.sequence = (this.sequence || 0) + 1;
    const focusGroup = document.activeElement?.closest('[data-group]')?.dataset.group;
    this.setAttribute('aria-busy', 'true');
    this.querySelector('.shp-loading').hidden = false;
    this.querySelector('[role=alert]').hidden = true;
    try {
      const request = new URL(url);
      request.searchParams.set('section_id', this.dataset.section);
      const response = await fetch(request, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (sequence !== this.sequence) return;
      const finder = doc.querySelector('shp-cart-finder');
      const grid = doc.getElementById('ProductGridContainer');
      if (!finder || !grid) throw new Error('Incomplete response');
      document.getElementById('ProductGridContainer').replaceWith(grid);
      this.replaceWith(finder);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
      if (historyUpdate) history.pushState({}, '', url);
      if (focusGroup) [...finder.querySelectorAll('[data-group]')].find(group => group.dataset.group === focusGroup)?.querySelector('input:checked')?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError' && sequence === this.sequence) this.querySelector('[role=alert]').hidden = false;
    } finally {
      if (sequence === this.sequence) {
        this.removeAttribute('aria-busy');
        this.querySelector('.shp-loading').hidden = true;
      }
    }
  }
  disconnectedCallback() { this.controller?.abort(); }
});
if (!window.shpFinderHistory) {
  window.shpFinderHistory = true;
  window.addEventListener('popstate', () => document.querySelector('shp-cart-finder')?.load(new URL(location.href), false));
}
